import React from 'react';
import {
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
  HStack,
  Text,
  Button,
  Image,
  RadioGroup,
  Radio,
  chakra,
  Box,
} from '@chakra-ui/react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/form-control';
import { useField } from 'formik';
import { ChevronDownIcon } from '@chakra-ui/icons';

const SelectFieldId = ({ label, options, placeholder, onChangeId, image, textButton, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const colorErro = meta.error ? { colorScheme: 'red' } : {};

  let selectedOption = options.find((opt) => opt.id === value);

  return (
    <FormControl isInvalid={meta.error}>
      <FormLabel>{label}</FormLabel>

      <Center>
        <Button
          onClick={onOpen}
          rightIcon={<ChevronDownIcon />}
          w="100%"
          maxW="380px"
          justifyContent="center" 
          pl={image ? 4 : 3}
          borderRadius="15px"
          {...field}
          {...props}
          {...colorErro}
        >
          <HStack spacing={3} justify="center" w="100%">
            {image && <Image src={image} boxSize="20px" />}
            <Text fontWeight="bold" color="#757575" textAlign="center">
              {textButton}
            </Text>
          </HStack>
        </Button>
      </Center>

      <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />

        <DrawerContent borderTopRadius="20px" maxH="70vh">
          <Center mt={2}>
            <Box w="40px" h="4px" bg="gray.300" borderRadius="full" />
          </Center>

          <DrawerHeader textAlign="center" pb={2}>
            Selecione um procedimento
          </DrawerHeader>

          <DrawerBody position="relative" p={0}>
            <Box px={4} pb="80px" maxH="55vh" overflowY="auto">
              {options.map((opt) => {
                const isSelected = value === opt.id;

                return (
                  <Box
                    key={opt.id}
                    onClick={() => {
                      setValue(opt.id);
                      onChangeId?.(opt.id);
                      onClose();
                    }}
                    p="14px"
                    mb="10px"
                    borderRadius="12px"
                    cursor="pointer"
                    transition="0.2s"
                    bg={isSelected ? 'teal.50' : 'white'}
                    border={isSelected ? '2px solid #319795' : '1px solid #E2E8F0'}
                    _active={{ transform: 'scale(0.98)' }}
                  >
                    <HStack justify="space-between">
                      <Text fontWeight="bold" color={isSelected ? 'teal.600' : '#757575'}>
                        {opt.label}
                      </Text>

                      {isSelected && <Box w="10px" h="10px" bg="teal.500" borderRadius="full" />}
                    </HStack>
                  </Box>
                );
              })}
            </Box>

            <Box position="absolute" bottom="0" left="0" right="0" height="40px" bgGradient="linear(to-t, white, transparent)" pointerEvents="none" />
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};

export default SelectFieldId;
